// src/components/Auth/AuthProvider.tsx
import { ReactNode } from 'react';
import { AuthProvider, AuthProviderProps } from 'react-oidc-context';
import { User } from 'oidc-client-ts';

interface AppAuthProviderProps {
  children: ReactNode;
}

const oidcConfig: AuthProviderProps = {
  authority: process.env.REACT_APP_COGNITO_AUTHORITY ?? '',
  client_id: process.env.REACT_APP_COGNITO_CLIENT_ID ?? '',
  // redirect_uri: process.env.REACT_APP_COGNITO_REDIRECT_URI ?? '',
  redirect_uri: `${process.env.REACT_APP_COGNITO_REDIRECT_URI}/auth-callback`, 
  response_type: "code",
  scope: "openid email phone",
  loadUserInfo: true,
  automaticSilentRenew: true,
  monitorSession: true,  // セッションモニタリングを無効化
  metadata: {
    issuer: process.env.REACT_APP_COGNITO_AUTHORITY ?? '',
    authorization_endpoint: `https://${process.env.REACT_APP_COGNITO_DOMAIN}/oauth2/authorize`,
    token_endpoint: `https://${process.env.REACT_APP_COGNITO_DOMAIN}/oauth2/token`,
    end_session_endpoint: `https://${process.env.REACT_APP_COGNITO_DOMAIN}/logout`,
    userinfo_endpoint: `https://${process.env.REACT_APP_COGNITO_DOMAIN}/oauth2/userInfo`
  }
};
export const AppAuthProvider = ({ children }: AppAuthProviderProps) => {
  return (
    <AuthProvider {...oidcConfig}>
      {children}
    </AuthProvider>
  );
};